import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../App"
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ } from "../../../../Custom/Custom";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateExcelASITable4 } from "../../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../../assets/Messages.json';
import asiTitle from '../../../../asi.json';

const Table4Report = () => {
  const [year,setYear]=useState([]);  
  const [yearName, setYearName] = useState("");
  const [tableReportData, setTableReportData] = useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });

  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  const storedLanguage = localStorage.getItem('language');



  //get Years 
  const getSurveyYears=async()=>{
    showLoading(true)
       try {
          const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
          const allYear = response.data;
          if (allYear.status) {
              setYear(allYear.data.surveyYearList.reverse())
              showLoading(false);
          }
    } catch (error) {
       console.error(error);
       showLoading(false);
    }finally{
       showLoading(false);
    }
  
  }


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    getSurveyYears()
  }, []);



  const handleDropdownChange = (e) => {
    setYearName(e.target.value);
  };

  const downloadStaticTable4Xlsx = async () => {
    const fileUrl = `pdf/ASI_Table4.xlsx`;
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("File not found");
      }
      const blob = await response.blob();
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = "ASI_Table4.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error(error);
      toast.error("File not found", messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };

  const handleGenerateExcel = () => {
    if (!yearName) {
      toast.error("Please select a Survey Year", messages.COLOR_RED);
      return;
    }

    showLoading(true);
    // Prepare payload
    const payload = {
      survey_year: yearName,
    };

    if (String(yearName) === "2023") {
      downloadStaticTable4Xlsx();
      return false;
    }
    // POST request to API
    axios
        .post(`${API_URL}api/asi/reports/HQReports/asigetTable4Report`, payload, config)
        .then((response) => {
            // Handle success and generate the Excel file directly
            const table4Report = response.data.data.asigetTable4DSLReportdata;

            if (!table4Report || table4Report.length === 0) {
              toast.error("Data not found",messages.COLOR_RED);
              showLoading(false);
              return;
            }

            let excelFileName = 'ASI_Table4';
            const excelObjectData = {
              fileName: excelFileName,
              reportType: excelFileName,
              fileType: 'xlsx',
              sheetName: "ASI_Table4",
              firstRowMergeCells: "A1:M1",
              firstRowExportData: 'सारिणी -४ ',
              firstRowCellNumber: 11,
              secondRowMergeCells: "A2:M2",
              secondRowText: `वार्षिक उद्योग सर्वेक्षण ${yearName}-${parseInt(yearName) + 1}`,
              thirdRowMergeCells: "A3:M3",
              thirdRowText: 'उत्तर प्रदेश के उद्योगों का रोजगार एवं परिलब्धियाँ',
              headerHindiColumns: [],
            };

            const transformedData = table4Report.map(item => [
              item.DIVISION_CODE,
              item.DISTRICT_CODE,
              item.nicCodePerframe,
              item.registered,
              item.working === "" ? '0' : item.working,
              item.estimated === "" ? '0' : item.estimated,
              item.labourDay === "" ? '0' : item.labourDay,
              item.staff === "" ? '0' : item.staff,
              item.supervisoryAndManagerialStaff === "" ? '0' : item.supervisoryAndManagerialStaff,
              item.otherStaff === "" ? '0' : item.otherStaff,
              item.allEmployees === "" ? '0' : item.allEmployees,
              item.totalEmolumentsStaff === "" ? '0' : item.totalEmolumentsStaff,
              item.totalEmolumentsAllEmployees === "" ? '0' : item.totalEmolumentsAllEmployees,
            ]);
            excelObjectData.excelRowData = transformedData;

            generateExcelASITable4(excelObjectData);

            showLoading(false);
        })
        .catch((error) => {
            console.error('API Error:', error);
            showLoading(false);
        });
};



  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                {/* <h3 style={{ color: '#F47720' }}>ASI Annual Survey of Industries, Uttar Pradesh</h3>
                <span><p>Table4 Report</p></span> */}
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.TABLE_FOUR_REPORT : asiTitle.en.TABLE_FOUR_REPORT }} />
              </h4>
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">
                  {storedLanguage === 'hi' ? asiTitle.hi.SURVEY_YAER : asiTitle.en.SURVEY_YAER}
                    </label>
                  <select
                    name="year_name"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                     {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                      ))}

                  </select>
                </div>
                <div className="col-xl-2 col-lg-12 mb-3">
                  <label className="w-100 d-none d-sm-block">&nbsp;</label>
                  <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Table4Report